import { render, staticRenderFns } from "./trumbowygWrapper.vue?vue&type=template&id=0d67c249&scoped=true&"
import script from "./trumbowygWrapper.vue?vue&type=script&lang=js&"
export * from "./trumbowygWrapper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d67c249",
  null
  
)

export default component.exports